module.exports = __webpack_public_path__ + "static/media/181IT128.5c85fc4a.jpg";